import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Admin from './Admin';
import PrizeDrawAdmin from './PrizeDrawAdmin';
import QuoteRequestsAdmin from './QuoteRequestsAdmin';
import CareerApplicationsAdmin from './CareerApplicationsAdmin';
import ImageOptionsDemo from './ImageOptionsDemo';
import CarouselDemo from './CarouselDemo';
import LogoCropDemo from './LogoCropDemo';

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/prize-draws" element={<PrizeDrawAdmin />} />
        <Route path="/admin/quote-requests" element={<QuoteRequestsAdmin />} />
        <Route path="/admin/career-applications" element={<CareerApplicationsAdmin />} />
        <Route path="/image-options" element={<ImageOptionsDemo />} />
        <Route path="/carousel-options" element={<CarouselDemo />} />
        <Route path="/logo-crop-options" element={<LogoCropDemo />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
